<template>
	<sf-data-table
		rowSize="lg"
		:excel="isButton_(scrId, 'EX')"
		index
		:customExcel="excelFunc"
		:columns="columns"
		:rows="rows"
		height="100%"
		@row-click="onRowClick"
		:rowClassName="rowClassName"
		paging
		:pageUnit="pageUnit_"
		:pageArray="screen.pageArray"
		:totalSize="totalSize_"
		@changedPage="changedPage"
	>
	</sf-data-table>
</template>

<script>
import columns from './columns';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SyncManagement/store/helpers';
import { utils } from '@sfaas/util';
import { BASE_URL } from '@/constants';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return columns.map(column => ({ ...column, label: this.getMessage_(column.msgKey) }));
		},
		rows() {
			return this.processes;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,

		changedPage({ currentPageVal, pageUnitVal }) {
			Promise.resolve()
				.then(() =>
					this.DEFAULT_ASSIGN({ key: 'pagingInfo', value: { ...this.pagingInfo, currentPage: currentPageVal, pageUnit: pageUnitVal } })
				)
				.then(this.findAllProcesses);
		},

		excelFunc() {
			const url = `${BASE_URL}/sync/v1/plants/${this.user.plantCd}/processes`;
			const params = { url, columns: this.columns };

			this.$sf_toggleLoading(true);
			this.xlsxDown(params)
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		onRowClick(row, column, event) {
			const { plantCd, procId } = row;
			this.DEFAULT_ASSIGN({ key: 'selectedRow', value: row });

			this.$sf_toggleLoading(true);
			this.fetchSqlDetails_({ plantCd, procId })
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		rowClassName({ row, rowIndex }) {
			return 'hover';
		},

		findAllProcesses() {
			this.$sf_toggleLoading(true);
			this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ })
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	created() {
		this.findAllProcesses();
		this.screen = this.screenArray.get(this.scrId);
	}
};
</script>

<style langType="scss">
.hover {
	/* TODO */
	cursor: pointer;
}
</style>
